import { render } from "./AddTasksModal.vue?vue&type=template&id=beb66edc&scoped=true"
import script from "./AddTasksModal.vue?vue&type=script&lang=js"
export * from "./AddTasksModal.vue?vue&type=script&lang=js"

import "./AddTasksModal.vue?vue&type=style&index=0&id=beb66edc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb66edc"]])

export default __exports__